import { Helmet } from 'react-helmet-async';

/**
 * Composant SEO pour la fiche hôtel
 * Gère les balises Open Graph pour WhatsApp, Facebook, iMessage
 * 
 * Usage : <HotelSEO data={data} avgRating={avgRating} totalReviews={totalReviews} />
 */
export default function HotelSEO({ data, avgRating, totalReviews }) {
  if (!data) return null;

  const title = `${data.name} — Réservez sur Komorotel`;
  const description = data.desc
    ? `${data.desc.slice(0, 150)}...`
    : `Réservez au ${data.name} à ${data.city}, ${data.island}. Disponibilités et tarifs sur Komorotel.`;

  const image = data.photos?.[0] || 'https://komorotel.com/og-default.jpg';
  const url = `https://komorotel.com/hotel/slug/${data.slug}`;

  const priceText = data.minPrice ? `À partir de ${data.minPrice} €/nuit` : '';
  const ratingText = avgRating ? ` · ⭐ ${avgRating}/5 (${totalReviews} avis)` : '';
  const fullDescription = `${priceText}${ratingText} — ${description}`;

  return (
    <Helmet>
      {/* ── Titre & description ───────────────────────────── */}
      <title>{title}</title>
      <meta name="description" content={fullDescription} />

      {/* ── Open Graph (Facebook, WhatsApp, iMessage) ────── */}
      <meta property="og:type"        content="hotel" />
      <meta property="og:site_name"   content="Komorotel" />
      <meta property="og:title"       content={title} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:image"       content={image} />
      <meta property="og:image:width"  content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url"         content={url} />
      <meta property="og:locale"      content="fr_FR" />

      {/* ── Twitter Card (aussi utilisé par d'autres apps) ── */}
      <meta name="twitter:card"        content="summary_large_image" />
      <meta name="twitter:title"       content={title} />
      <meta name="twitter:description" content={fullDescription} />
      <meta name="twitter:image"       content={image} />

      {/* ── Canonical ─────────────────────────────────────── */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
}